import { render } from "./AppConfigPage.vue?vue&type=template&id=5b1f1192&scoped=true&ts=true"
import script from "./AppConfigPage.vue?vue&type=script&lang=ts"
export * from "./AppConfigPage.vue?vue&type=script&lang=ts"

import "./AppConfigPage.vue?vue&type=style&index=0&id=5b1f1192&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1f1192"]])

export default __exports__